








































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import { DrivewealthWizardStep } from "@/shared/types";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class InvestWithDrivewealthWidget extends Vue {
  @Prop() hasMoreThanThreshold: boolean;
  @Prop() hsaInvestmentThreshold: number;
  DrivewealthWizardStep = DrivewealthWizardStep;
  formatCurrency = formatCurrency;
  RouteNames = RouteNames;
}

